<script>
  // Add External Scripts and Styles in Index.html (public)

  import Navigation from "./components/Navigation.svelte";
  import Select from "./components/Select.svelte";
  import Club from "./components/Club.svelte";
  import {teams} from "./clubs.js"

  let club = "";

  // change handler for select
  const selectChange = (e) => {
    club = e.detail;
    // find team that matches club passed in to pass to clubs

    for (let i = 0; i < teams.length; i++) {
      if (teams[i].id === club) {
        team = teams[i];
        break;
      }
    }
  };

  //teams

  let team = [];

 
</script>

<style>

</style>

<main>
  <Navigation active="clubs" />

  <Select {club} on:selectChange={selectChange} />
  <Club {team} />
</main>
